import { Component } from '@angular/core';

@Component({
  selector: 'qas-root',
  templateUrl: './root.component.html'
})
export class RootComponent {
}
